import React, { useState } from "react";
import "./TextZone.css";

const TextZone = (props) => {
  const [focus, setFocus] = useState(false);
  
  return (
    <div className="text-zone-container">
      <div className="text-zone-title">{props.titre}</div>

      <div>
        <input
          className={`text-zone-input ${focus ? 'text-zone-input-focus' : ''}`}
          placeholder={props.titre}
          value={props.value}
          onChange={(e) => props.onEdit(e.target.value)}
          type={props.keyboardType === 'numeric' ? 'number' : 'text'}
          maxLength={props.maxLength}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          disabled={props.editable === false}
        />
        {props.attention && (
          <div className="text-zone-error">{props.attention}</div>
        )}
      </div>
    </div>
  );
};

export default TextZone;